import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiEmptyResponse } from './feel-subscription.api.models';

import { HttpRequestsService } from '@core/infrastructure/http-requests/http-requests.service';

@Injectable()
export class FeelSubscriptionApiRepository {
    constructor(
        private readonly http: HttpClient,
        private readonly requestService: HttpRequestsService,
    ) {}

    public signUp(storeId: string, languageId: string): Observable<ApiEmptyResponse> {
        const slug = `user/store/${storeId}/crm`;
        const url = this.requestService.requestUrl(slug, languageId, null, true);

        return this.http.post<ApiEmptyResponse>(url, {});
    }
}
